<template lang="pug">
  server-data(
    search-field-name="search[name]"
    :method="getMunicipalities"
    v-slot="{ serverData: municipalities, loading, search }"
  )
    app-autocomplete(
      v-bind="extendAttrs"
      :loading="loading"
      :items="municipalities"
      @update:search-input="search"
      @input="(val) => $emit('input', val)"
    )
</template>

<script>
import { PER_PAGE } from '@/constants/pagination';

export default {
  props: {
    regionId: {
      type: Number,
      default: null,
    },
    value: {
      type: [Number, String, Object],
      default: null,
    },
  },
  computed: {
    extendAttrs() {
      const { $attrs, value } = this;

      return {
        ...$attrs,
        value,
      };
    },
  },
  watch: {
    regionId(val) {
      if (!val) this.$emit('input', null);
    },
  },
  methods: {
    getMunicipalities({ params: additionalParams }) {
      const params = {
        ...additionalParams,
        'search[region_id]': this.regionId,
        'per-page': PER_PAGE.infinity,
        sort: 'name',
      };

      return this.$api.dir.getMunsCached(params);
    },
  },
};
</script>
